module.exports = __webpack_public_path__ + "media/honey-icons/icon-wifi-active-full-4f63e2c3.svg";